/**
 * 模块名称：业绩调整历史详情
 * @author zuoshen@372163.com
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Row,
  Col,
  Descriptions,
  Button,
  Spin
} from 'antd'

const DItem = Descriptions.Item

let areaTxt = '', result = ''

const DetailHistory = (props) => {

  const { history, location } = props

  const [orderInfo, setOrderInfo] = useState([])//收款信息
  const [historyInfo,setHistoryInfo] = useState([])
  const [loading, setLoading] = useState(true) 
 
  useEffect(() => {
    areaTxt = ''
    result = ''
    if (location.state) {
      getPerformanceAdjDetailHistory(location.state.orderId,location.state.id)
    } else {
      history.push({
        pathname: `/performance/personal`,

      })
    }
  }, []) 

  //获取历史详情
  const getPerformanceAdjDetailHistory = (orderId,id) => { 
    api.perfAdjHistory({ orderId: orderId,id:id }).then(res => { 
      if (JSON.stringify(res) !== "[]") {
        let data = Object.assign({}, res) 
				if (data) {
          setOrderInfo(data.orderInfo) 
          setHistoryInfo(data.history)
				} 
      }  
      setLoading(false)
    })
  }
  

  return (
    <Spin spinning={loading}>
      <div className="add-orderDirect-detail"> 
        <Descriptions title={`业绩调整 订单编号: ${orderInfo.number || ''}`} layout="vertical" className="pro-detail-title" column={5} style={{ borderBottom: "none" }}>
          <DItem label="客户名称">{orderInfo.client}</DItem>
          <DItem label="OAID">{orderInfo.clientId}</DItem>
          <DItem label="厂商ID">{orderInfo.vendor}</DItem>
          {orderInfo.type == 0 && <DItem label="所属销售">{orderInfo.relSalerName}</DItem>}
					{orderInfo.type == 0 && <DItem label="所属客服">{orderInfo.relServicerName}</DItem>}
					{orderInfo.type == 1 && <DItem label="供应商所属开发">{orderInfo.relAgentStaffName}</DItem>}
					{orderInfo.type == 1 && <DItem label="提单人">{orderInfo.userName}</DItem>}
        </Descriptions>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单信息</div>
          {orderInfo ? <Descriptions layout="vertical" className="pro-detail-title" column={3} style={{ borderBottom: "none" }}>
            <DItem label="项目">{orderInfo.projectName}</DItem>
            <DItem label="产品">{orderInfo.productName}</DItem>
            <DItem label="业务类型">{orderInfo.businessName}</DItem>
            <DItem label="业绩类型">{orderInfo.figtypeName}</DItem>
            {orderInfo.type == '0' && <DItem label="是否撤资重开订单">{orderInfo.isodfdivestName}</DItem>}
							{orderInfo.type == '0' && <DItem label="是否退转订单">{orderInfo.isodftrunName}</DItem>}
							{orderInfo.type == '0' && <DItem label="是否框架订单">{orderInfo.isodfkjiaName}</DItem>}
							{orderInfo.type == '0' && <DItem label="销售主项">{orderInfo.majorminorName}</DItem>}
							{orderInfo.type == '1' && <DItem label="代理商名称">
              <div>{orderInfo.agent}</div>
              <div>ID: {orderInfo.agentId}</div>
            </DItem>}
          </Descriptions> : '-'}
        </div> 
        <div className="blank-line"></div>
        {historyInfo.map((item,index) => {
          return (<div key={index}>
            <div className="ask-info"  >
              <div className="record-list-title">订单收款信息-{item.affectDate}</div>
              <Descriptions layout="vertical" className="pro-detail-title"column={3} style={{ borderBottom: "none" }}>
                <DItem label="市场价">{item.colmarketprice}</DItem>
                <DItem label="实收">{item.colactualprice}</DItem>
                <DItem label="折扣">{item.colrebate}</DItem>
                <DItem label="个人利润">{item.colProfit}</DItem>
                <DItem label="成本">{item.colCost}</DItem>
                <DItem label="调整项">{item.colRefund}</DItem>
                <DItem label="提单人">{item.userName}</DItem>
                <DItem label="直接主管">{item.userLeaderName}</DItem>
                <DItem label="部门">{item.userDeptName}</DItem>
              </Descriptions> 
            </div>
            <div className="blank-line"></div>
            <div className="ask-info"  key={index+'a1'}>
              <div className="record-list-title">业绩分配信息-{item.auditTime}</div>
              {item.allotInfo.map((perf,key) => {
                return (
                  <Descriptions layout="vertical" key={key} column={4} className="pro-detail-title" style={{ borderBottom: "none" }}>
                    <DItem label="业绩">{perf.cost}</DItem>
                    <DItem label="分成人">{perf.userName}</DItem>
                    <DItem label="直接主管">{perf.leader}</DItem>
                    <DItem label="部门">{perf.department}</DItem>
                  </Descriptions>
                )
              })}
              <Descriptions layout="vertical" column={4} className="pro-detail-title" style={{ borderBottom: "none" }}>
                <DItem label='备注'>
                  {item.remark}
                </DItem>
              </Descriptions>
            </div>
            <div className="blank-line"></div>
          </div>
          )
        })}
      </div>
      <Row type="flex" justify="center" align="middle">
      <Col>
          <div className="btns" style={{paddingTop: 20}}><Button type="primary" onClick={()=>{history.go(-1)}}>返回</Button></div>
      </Col>
      </Row>
     
    </Spin>
  )
}

export default DetailHistory